import * as Api from '@ViewModels';

const integrationProviderDisplayNames: Record<string, string> = {
	[Api.IntegrationProvider.PracticePanther]: 'Practice Panther',
	[Api.IntegrationProvider.MicrosoftDynamics365Sales]: 'Microsoft Dynamics 365 Sales',
	[Api.IntegrationProvider.MyCase]: 'MyCase',
	[Api.IntegrationProvider.Eclipse]: 'Eclipse',
	[Api.IntegrationProvider.Clio]: 'Clio',
	[Api.IntegrationProvider.Salesforce]: 'Salesforce',
	[Api.IntegrationProvider.ServiceTitan]: 'ServiceTitan',
	[Api.IntegrationProvider.QuickBooksOnline]: 'QuickBooks Online',
	[Api.IntegrationProvider.Wealthbox]: 'Wealthbox',
	[Api.IntegrationProvider.Redtail]: 'Redtail',
	[Api.IntegrationProvider.Bloomerang]: 'Bloomerang',
	[Api.IntegrationProvider.CasePeer]: 'CasePeer',
	[Api.IntegrationProvider.DonorPerfect]: 'DonorPerfect',
	[Api.IntegrationProvider.Filevine]: 'Filevine',
	[Api.IntegrationProvider.MedicarePro]: 'MedicarePRO CRM',
	[Api.IntegrationProvider.HawkSoft]: 'HawkSoft',
	[Api.IntegrationProvider.HubSpot]: 'HubSpot CRM',
};

export const getProviderDisplayName = (provider: Api.IntegrationProvider) =>
	integrationProviderDisplayNames[provider] ?? provider;
